$('.ttgNCECountdown').each(function() {
    $(this).find(".ttgCountdownHours").countdown($(this).data('finaldate'), function(event) {
        $(this).text(
            event.strftime('%H')
        );
    });
    $(this).find(".ttgCountdownDays").countdown($(this).data('finaldate'), function(event) {
        $(this).text(
            event.strftime('%D')
        );
    });
    $(this).find(".ttgCountdownMinutes").countdown($(this).data('finaldate'), function(event) {
        $(this).text(
            event.strftime('%M')
        );
    });
    $(this).find(".ttgCountdownSeconds").countdown($(this).data('finaldate'), function(event) {
        $(this).text(
            event.strftime('%S')
        );
    });
});